export default __webpack_public_path__ + "static/media/insta.cef6ceca.svg";